import {api} from './api';
import {beginBiteLoginMeasurement} from './bite-login-measurement';
import {hasAnalyticsConsent} from './consent';
import {withBiteCampaign} from './bite-campaign-source';
import {checkoutFlowDetails} from './bite-conversion';
import {trackBiteEvent} from './bite-measurement';

let pending: Promise<void> | null = null;
let captured = false;
let firstCandidate: string | null = null;
let revision=0;
let cleared=false;
let loginPickerOpen=false;
export const isBiteLoginOpen=()=>loginPickerOpen;
export function closeBiteLogin(){loginPickerOpen=false;window.dispatchEvent(new Event('bite:login:close'));}
export function captureBiteSignupReferral(): Promise<void> {
  if(pending)return pending;
  if(captured||!hasAnalyticsConsent())return Promise.resolve();
  const fragment=new URLSearchParams(location.hash.slice(1));
  const firstReferral=firstCandidate||fragment.get('bs_signup_ref');
  if(!firstReferral||!/^[a-f0-9]{64}$/.test(firstReferral))return Promise.resolve();
  firstCandidate=firstReferral;
  cleared=false;
  const started=revision;
  pending=api('/api/bite/signup-referral',{method:'POST',body:{firstReferral,consent:true},signal:AbortSignal.timeout(5000)})
    .then(()=>{
      if(started!==revision)return;
      captured=true;
      const current=new URLSearchParams(location.hash.slice(1));
      current.delete('bs_signup_ref');
      history.replaceState(history.state,'',location.pathname+location.search+(current.size?`#${current}`:''));
    }).catch(()=>{}).finally(()=>{pending=null;});
  return pending;
}
export function clearBiteSignupReferral() {
  if(cleared)return;
  cleared=true;
  revision++;
  firstCandidate=null;
  captured=false;
  const fragment=new URLSearchParams(location.hash.slice(1));
  fragment.delete('bs_signup_ref');
  history.replaceState(history.state,'',location.pathname+location.search+(fragment.size?`#${fragment}`:''));
  void (pending||Promise.resolve()).then(()=>api('/api/bite/signup-referral',{method:'POST',body:{consent:false},signal:AbortSignal.timeout(5000)})).catch(()=>{});
}
export async function openBiteLogin(next: string) {
  loginPickerOpen=true;
  const event = new CustomEvent('bite:login', {detail: {next}, cancelable: true});
  window.dispatchEvent(event);
  if (!event.defaultPrevented) {loginPickerOpen=false;window.location.assign(withBiteCampaign(`/bite/login?next=${encodeURIComponent(next)}`));}
}
export async function startBiteLogin(next: string,provider:'google'|'apple'='google') {
  beginBiteLoginMeasurement(next);
  trackBiteEvent(provider==='apple'?'login_apple':'login_google',checkoutFlowDetails(next));
  await captureBiteSignupReferral();
  window.location.assign(withBiteCampaign(`/auth/${provider}?next=${encodeURIComponent(next)}`));
}
